"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sms = exports.post = exports.phone = exports.marketingPreferencesConfig = exports.email = exports.MarketingPreferencesDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var CheckboxDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.CheckboxDefinition;
});

var RadioDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.RadioDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var email = {
  confirmText: "Are you sure? We'd love to keep you updated on other ways you can help with our lifesaving work. But we will only do this if you choose Yes. <strong>You can change your mind at any time.</strong>",
  key: 'email',
  label: 'Email',
  normalize: 'boolean',
  type: 'radio',
  items: [{
    key: 'yes',
    label: 'Yes',
    value: 'true'
  }, {
    key: 'no',
    label: 'No',
    value: 'false'
  }],
  ui: {
    classes: 'large',
    labelPosition: 'left'
  },
  validation: [{
    required: true
  }]
};
exports.email = email;
var sms = {
  confirmText: "Are you sure? We'd love to keep you updated on other ways you can help with our lifesaving work. But we will only do this if you choose Yes. <strong>You can change your mind at any time.</strong>",
  key: 'sms',
  label: 'Text message',
  normalize: 'boolean',
  type: 'radio',
  items: [{
    key: 'yes',
    label: 'Yes',
    value: 'true'
  }, {
    key: 'no',
    label: 'No',
    value: 'false'
  }],
  ui: {
    classes: 'large',
    labelPosition: 'left'
  },
  validation: [{
    required: true
  }]
};
exports.sms = sms;
var phone = {
  confirmText: "Are you sure? We'd love to keep you updated on other ways you can help with our lifesaving work. But we will only do this if you choose Yes. <strong>You can change your mind at any time.</strong>",
  key: 'phone',
  label: 'Phone',
  normalize: 'boolean',
  type: 'radio',
  items: [{
    key: 'yes',
    label: 'Yes',
    value: 'true'
  }, {
    key: 'no',
    label: 'No',
    value: 'false'
  }],
  ui: {
    classes: 'large',
    labelPosition: 'left'
  },
  validation: [{
    required: true
  }]
};
exports.phone = phone;
var post = {
  key: 'post',
  normalize: 'boolean',
  type: 'checkbox',
  items: [{
    key: 'postCheckbox',
    label: 'Please tick this box if you would prefer not to get post from us.'
  }],
  ui: {
    classes: 'large',
    descriptionPosition: 'before'
  },
  validation: []
};
exports.post = post;
var marketingPreferencesConfig = {
  type: 'marketingPreferences',
  fields: [email, sms, phone, post]
};
exports.marketingPreferencesConfig = marketingPreferencesConfig;

var MarketingPreferencesDefinition = _flowRuntime["default"].type("MarketingPreferencesDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("marketingPreferences")), _flowRuntime["default"].property("options", _flowRuntime["default"].object(_flowRuntime["default"].property("email", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("phone", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("post", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("sms", _flowRuntime["default"]["boolean"]()))))));

exports.MarketingPreferencesDefinition = MarketingPreferencesDefinition;